import { render, staticRenderFns } from "./UserAliases.vue?vue&type=template&id=d4d8b77a&scoped=true"
import script from "./UserAliases.vue?vue&type=script&lang=ts"
export * from "./UserAliases.vue?vue&type=script&lang=ts"
import style0 from "./UserAliases.vue?vue&type=style&index=0&id=d4d8b77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d8b77a",
  null
  
)

export default component.exports